import { useSidebarOpenState, Link } from '@backstage/core-components';
import { FeatureFlagged } from '@backstage/core-app-api';
import Stack from '@mui/material/Stack';
import {
  FullSideBarLogoIcon,
  NotificationBadge,
  FullSideBarLogoB,
} from '@internal/backstage-plugin-hm-react';
import { sidebarCssVars } from './sidebar-vars';
import styles from './sidebar.module.css';

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={styles.root} style={sidebarCssVars} data-open={isOpen}>
      {isOpen ? (
        <Stack
          direction="row"
          justifyContent="center"
          width="100%"
          style={{ alignItems: 'flex-start' }} // Note: Need to be as styles and not prop to override MUI
        >
          <Link to="/" underline="none" aria-label="Home">
            <FeatureFlagged without="threaddy">
              <FullSideBarLogoIcon />
            </FeatureFlagged>
            <FeatureFlagged with="threaddy">
              <FullSideBarLogoB />
            </FeatureFlagged>
          </Link>
          <FeatureFlagged without="hide-notification-badge-on-logo">
            <NotificationBadge withLink className={styles.notificationBadge} />
          </FeatureFlagged>
        </Stack>
      ) : (
        <Stack direction="row" justifyContent="center">
          <Link to="/" underline="none" aria-label="Home">
            <FullSideBarLogoB height={1.3} />
          </Link>
          <NotificationBadge
            withLink
            size="small"
            className={styles.notificationBadge}
          />
        </Stack>
      )}
    </div>
  );
};
